import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector'; // 임시로 비활성화

import koTranslation from './locales/ko/translation.json';
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';

i18n
  // .use(LanguageDetector) // 임시로 비활성화
  .use(initReactI18next)
  .init({
    lng: 'ko', // 한국어로 고정
    resources: {
      ko: {
        translation: koTranslation,
      },
      en: {
        translation: enTranslation,
      },
      es: {
        translation: esTranslation,
      },
    },
    fallbackLng: 'ko',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n; 